/* WebComponentFloatButton component */
/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging -- disabled to allow to inherit from AbstractComponent */
import { Component, Element, h, Prop } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import FloatButtonTemplate from './cwc-float-button.template';
import { AbstractComponent } from '@cewe-designsystem/abstract';

/**
 * @slot icon - HTML element used as caption for the button e.g. an img or svg
 */
@Component({
  tag: 'cwc-float-button',
  styleUrl: './cwc-float-button.scss',
  shadow: true,
})
export class FloatButtonComponent {
  /**
   * element
   */
  @Element()
  element: HTMLElement;

  /**
   * The icon to be shown in the button.
   */
  @Prop({ reflect: false })
  icon: string = '';

  /**
   * If true the button is scaled bigger
   *
   * @docs
   * @property {boolean} isLarge
   */
  @Prop() large: boolean = false;

  /**
   * render
   */
  render() {
    return <FloatButtonTemplate controller={this} />;
  }
}

/**
 * mixin abstract functions
 */
Object.setPrototypeOf(FloatButtonComponent.prototype, AbstractComponent.prototype);

export interface FloatButtonComponent extends AbstractComponent {}
